import React from 'react'
import ReactDOM from 'react-dom'

import { SkeletonTheme } from 'react-loading-skeleton'

import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'

import config from 'config'
import { epics, reducers } from 'modules'

import App from './layouts/App'

import '@driftt/react-dates/initialize'
import 'components/charts/highcharts/init'

import '@driftt/react-dates/lib/css/_datepicker.css'
import './index.css'

LoadStyles()

const renderConnectedApp = () => <App />

ReactDOM.render(
  <SkeletonTheme color="var(--color-p1-3)" highlightColor="var(--color-p1-2)">
    <ConnectedApp
      reducers={reducers}
      epics={epics}
      render={renderConnectedApp}
      sentryId={config.SENTRY_KEY}
      vNext
    />
  </SkeletonTheme>,
  document.getElementById('root')
)
